import React, { ReactElement } from 'react';
import { ActionsContext, ActionsContextValue } from './ActionsContext';

const ActionsContextProvider = ({ children, value }: { children: ReactElement; value: ActionsContextValue }) => (
    <ActionsContext.Provider value={value}>{children}</ActionsContext.Provider>
);

export default ActionsContextProvider;
